'use strict';

const config = {
    submitEvent: 'click',
    triggerTarget: '.js-add-to-basket',
    toggleClass: 'js-add-to-basket--added',
    basketCount: '.js-basket-count',
    basket: '.js-basket',
    loggedInClass: 'c-header--loggedin',
    headerElement: '.c-header'
};

class AddToBasket {

    constructor() {
        this.setupClickEvents();
    }

    /**
     * Sets up all events for add to list component.
     */
    setupClickEvents() {

        $(config.triggerTarget).each( function () {
            $(this).on(config.submitEvent, function (e) {
                e.preventDefault();
                const $this = $(this);
                const ajaxUrl = $this.data('ajaxUrl');
                const stockNumber = String($this.data('stocknumber')).split(",");
                const quantity = String($this.data('quantity')).split(",");

                $.ajax({
                    url: ajaxUrl,
                    data: { stockNumber: stockNumber, quantity: quantity},
                    success: function(result, textStatus, request) {
                        $this.addClass(config.toggleClass);
                        $(config.headerElement).addClass(config.loggedInClass);
                        $(config.basket).removeClass('is-hidden');
                        $(config.basketCount).text(request.getResponseHeader('x-item-count'));
                    }
                });
            });
        });
    }
}

$(window).load(function(){
    new AddToBasket();
});



// WEBPACK FOOTER //
// ./src/js/components/add-to-basket.js